import { GetterTree } from 'vuex'
import { CallSoundsState } from "@/store/call/sounds/types";
import { RootState } from '@/store/types';

export const getters: GetterTree<CallSoundsState, RootState> = {
  sounds:state => state.sounds,
  soundItem:state => state.soundItem,
};